function c() {
  var e = document.getElementsByTagName("link"), t = "";
  return Array.prototype.slice.call(e).forEach(function(n) {
    n.getAttribute("rel") === "canonical" && (t = n.getAttribute("href"));
  }), t;
}
function f() {
  var e = c();
  if (!e)
    return window.location.pathname;
  var t = document.createElement("a");
  t.href = e;
  var n = t.pathname.startsWith("/") ? t.pathname : "/" + t.pathname;
  return n;
}
function l(e) {
  e === void 0 && (e = "");
  var t = c();
  if (t)
    return t.includes("?") ? t : "".concat(t).concat(e);
  var n = window.location.href, r = n.indexOf("#");
  return r === -1 ? n : n.slice(0, r);
}
function u() {
  return {
    path: f(),
    referrer: document.referrer,
    search: location.search,
    title: document.title,
    url: l(location.search)
  };
}
function a(e) {
  var t, n = e.event;
  n.context = n.context || {};
  var r = u(), i = (t = n.properties) !== null && t !== void 0 ? t : {};
  return Object.keys(r).forEach(function(o) {
    i[o] && (r[o] = i[o]);
  }), n.context.page && (r = Object.assign({}, r, n.context.page)), n.context = Object.assign({}, n.context, {
    page: r
  }), e.event = n, e;
}
var p = {
  name: "Page Enrichment",
  version: "0.1.0",
  isLoaded: function() {
    return !0;
  },
  load: function() {
    return Promise.resolve();
  },
  type: "before",
  page: function(e) {
    return e.event.properties = Object.assign({}, u(), e.event.properties), e.event.name && (e.event.properties.name = e.event.name), a(e);
  },
  alias: a,
  track: a,
  identify: a,
  group: a
};
export {
  l as canonicalUrl,
  u as pageDefaults,
  p as pageEnrichment
};
//# sourceMappingURL=index35.js.map
